import { render, staticRenderFns } from "./IconEmptyQuoteCart.vue?vue&type=template&id=9f5d36c6&scoped=true&"
import script from "./IconEmptyQuoteCart.vue?vue&type=script&lang=ts&"
export * from "./IconEmptyQuoteCart.vue?vue&type=script&lang=ts&"
import style0 from "./IconEmptyQuoteCart.vue?vue&type=style&index=0&id=9f5d36c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d36c6",
  null
  
)

export default component.exports